export const messages = {
  en: {
    partnerLog: {
      queryCondition: 'Query Conditions',
      inputUserName: 'Please enter username',
      selectLogAction: 'Please select log action',
      selectStatus: 'Please select status',
      selectStartTime: 'Please select start time',
      selectEndTime: 'Please select end time',
      query: 'Query',
      partnerLog: 'Partner Log',
      serialNumber: 'No.',
      logAction: 'Log Action',
      userId: 'User ID',
      userName: 'User Name',
      status: 'Status',
      success: 'Success',
      fail: 'Fail',
      deliveryTime: 'Delivery Time',
      operation: 'Operation',
      message: 'Message'
    },
    showPartnerLog: {
      accessLog: 'Access Log',
      requestMessage: 'Request Message',
      responseMessage: 'Response Message',
      cancel: 'Cancel'
    }
  },
  zh: {
    partnerLog: {
      queryCondition: '查询条件',
      inputUserName: '请输入用户名',
      selectLogAction: '请选择日志动作',
      selectStatus: '请选择状态',
      selectStartTime: '请选择开始时间',
      selectEndTime: '请选择结束时间',
      query: '查询',
      partnerLog: '合作日志',
      serialNumber: '编号',
      logAction: '日志动作',
      userId: '用户ID',
      userName: '用户名称',
      status: '状态',
      success: '成功',
      fail: '失败',
      deliveryTime: '下发时间',
      operation: '操作',
      message: '报文'
    },
    showPartnerLog: {
      accessLog: '门禁日志',
      requestMessage: '请求报文',
      responseMessage: '返回报文',
      cancel: '取消'
    }
  }
}